export const PUBLIC_ROUTES = ['/auth', '/recover-password'];

export const PUBLIC_ROUTES_WITH_TOKEN = ['/auth/request', '/auth/verify'];

export const AUTH_ROUTES = [
  '/auth',
  '/register',
  '/recover-password',
  '/surfer-register',
];
